export const universal = {
    port: 9393,
};
